import { Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import Flex from "../../../../components/Flex/Flex";
import useSearchInput from "../../../ui/hooks/useSearchInput";

import AgreementAppendixesCollectionDataTable from "../../../agreements/components/AgreementAppendixesCollectionDataTable/AgreementAppendixesCollectionDataTable";
import CreateAppendixButton from "../../../agreements/components/CreateAppendix/CreateAppendixButton";

export default function SuperAdminAppendixesView() {
	const { t } = useTranslation();

	const [searchInput, searchQuery] = useSearchInput();

	return (
		<>
			<Flex gap={10} wrap style={{ marginBottom: 15 }}>
				<div>
					<Header as="h2">{t("appendixes", "Appendixes")}</Header>
				</div>

				<div style={{ whiteSpace: "nowrap" }}>
					<Flex gap={10} justifyContent="flex-start">
						{searchInput}

						<CreateAppendixButton primary />
					</Flex>
				</div>
			</Flex>

			<AgreementAppendixesCollectionDataTable searchQuery={searchQuery} />
		</>
	);
}
